import { Box, styled, Typography } from '@mui/material';

export const OfflineContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  backgroundColor: '#f2f2f2',
  boxSizing: 'border-box',
}));

export const TextContainer = styled(Box)(() => ({
  textAlign: 'center',
  padding: '20px',
  borderRadius: '8px',
  backgroundColor: '#fff',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  maxWidth: '600px',
  width: '90%',
}));

export const Title = styled(Typography)(() => ({
  color: '#666',
  marginBottom: '20px',
}));

export const BodyText = styled(Typography)(() => ({
  color: '#444',

  '&:first-of-type': {
    marginBottom: '10px',
  },
}));
